import type { DataOption } from '@/common.types'

import { useEffect } from 'react'
import { map, paths, pipe } from 'lodash/fp'
import { useTranslation } from 'react-i18next'

import { useOptimizationGroupsQuery } from '@/entities/optimization-group'

import { RHFMultiSelect } from '@/shared/components/HookForm'
import { Separator } from '@/shared/components/ui/separator'
import { Skeleton } from '@/shared/components/ui/skeleton'
import { ampli } from '@/shared/lib/ampli'
import { toOption } from '@/shared/tools/utils'

export const GeneralTab = () => {
	const { t } = useTranslation()

	useEffect(() => {
		ampli.anchoringAnchorStrategyOpenGeneral()
	}, [])
	const optimizationGroupsQuery = useOptimizationGroupsQuery<DataOption[]>({
		select: pipe([map(paths(['id', 'name'])), toOption]),
	})

	return optimizationGroupsQuery.isLoading ? (
		<div className='space-y-2'>
			<Skeleton className='h-5 w-24' />
			<Skeleton className='h-5 w-full' />
		</div>
	) : (
		<div className='space-y-4'>
			<Separator className='mb-4' />
			<RHFMultiSelect
				label={t('anchoring_management.create_strategy.ogs.title')}
				className='w-full'
				isLoading={optimizationGroupsQuery.isLoading}
				defaultValue={[]}
				name='optimization_group_ids'
				options={(optimizationGroupsQuery?.data as DataOption[]) || []}
			/>
		</div>
	)
}
